import type { JSX } from "react";

export const CertificateProceduresFooter = (): JSX.Element => {
  return (
    <p className="text-xs text-neutral-500 text-center">
      Ao continuar, você declara que leu e concorda com o{" "}
      <a
        href="https://ajuda.livance.com.br/hc/pt-br/articles/33268318835603"
        target="_blank"
        rel="noopener noreferrer"
        className="font-bold underline text-neutral-500"
      >
        Guia de Práticas da Livance
      </a>
      .
    </p>
  );
};
